import React from "react";
import { Container, Image } from "react-bootstrap";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";
import '../styles/Brand.css';
import { Helmet } from "react-helmet";


const About = () => {
    const containerStyle = {
    backgroundImage: 'url("/images/image_309.png")',
    backgroundSize: 'cover',
    width: '100vw',
    height: 'auto'
  };
    return(
        <div style={containerStyle}>
            <Helmet>
            <title>Оборудование для кухни из нержавеющей стали</title>
        <meta name="description" content="МЕБЕЛЬ ИЗ ВЫСОКОКАЧЕСТВЕННОЙ НЕРЖАВЕЮЩЕЙ СТАЛИ AISI 304 И AISI 430, оборудование для кухни, комплексное оснащение гостиниц и ресторанов, HORECA, Kromsan" />
            </Helmet>
        <Container>
            <Image className="pt-5 pb-4" width={200} height={150} src="/images/logo.png"/>
        <h1 className="pt-3">КОМПАНИЯ KROMSAN</h1>
        <p>
        Ведет свою деятельность в сфере промышленного оборудования и мебели из нержавеющей
         стали с 2015 года и по сей день. Благодаря результативной деятельности, опытному и квалифицированному
         персоналу стала одной из лидирующих компаний на территории Казахстана в своем секторе. Наша цель – поставлять высококачественную продукцию
         с учетом пожеланий клиента, а также оказывать профессиональный подход ко всем Вашим запросам из категории «Промышленное оборудование и мебель из нержавеющей стали.»
        </p>
            <h1>МЫ ПРЕДЛАГАЕМ:</h1>
        <p>
        Столешницы, сервисные тележки, стеллажи, производственные столы, трапы, моечные
         ванные, линии раздач, технические раковины, вытяжные зонты, подтоварники, 
        полки для корзины, освещение для вытяжки, линии горячего и холодного сервиса,
         а также Тепловое оборудование, Холодильное оборудование под торговой маркой COTTO 
        </p>
        <Image className="pt-5" width={150} height={100} src="/images/cotto.png"/>
            <ul className="pt-5" style={{ textAlign: 'left' }}>
                <li>Собственное производство!</li>
                <li>Все изделия только из качественных марок нержавеющей стали (AISI304 и AISI430) толщиной от 1 мм.</li>
                <li>Спроектируем изделия любой сложности.</li>
                <li>Технологии исполнения изделий заимствованы у Итальянских производителей.</li>
                <li>Изготовление изделий по Вашим габаритам вплоть до миллиметров.</li>
                <li>Гарантия на все изделия 1 год.</li>
            </ul>
        <h1 className="mt-5 mb-5">НАШИ ПРОЕКТЫ И КЛИЕНТЫ</h1>
        <ScrollAnimation animateIn="animate__fadeIn" duration={2} animateOnce={true}>
            <div className="brandsContentWrap">
                <Image className="brandItem " src="/images/1.png"/>
                <Image className="brandItem " src="/images/2.png"/>
                <Image className="brandItem " src="/images/3.png"/>
                <Image className="brandItem " src="/images/4.png"/>
                <Image className="brandItem " src="/images/5.png"/>
                <Image className="brandItem " src="/images/6.png"/>
                <Image className="brandItem " src="/images/7.png"/>
                <Image className="brandItem " src="/images/8.png"/>
                <Image className="brandItem " src="/images/9.png"/>
                <Image className="brandItem " src="/images/10.png"/>
                <Image className="brandItem " src="/images/11.png"/>
                <Image className="brandItem " src="/images/12.png"/>
                <Image className="brandItem " src="/images/13.png"/>
                <Image className="brandItem " src="/images/14.png"/>
                <Image className="brandItem " src="/images/15.png"/>
                <Image className="brandItem " src="/images/16.png"/>
                <Image className="brandItem " src="/images/17.png"/>
                <Image className="brandItem " src="/images/18.png"/>
                <Image className="brandItem " src="/images/19.png"/>
                <Image className="brandItem " src="/images/20.png"/>
                <Image className="brandItem " src="/images/21.png"/>
                <Image className="brandItem " src="/images/22.png"/>
                <Image className="brandItem " src="/images/23.png"/>
                <Image className="brandItem " src="/images/24.png"/>
                <Image className="brandItem " src="/images/25.png"/>
                <Image className="brandItem " src="/images/26.png"/>
                <Image className="brandItem " src="/images/27.png"/>
                <Image className="brandItem " src="/images/28.png"/>
                <Image className="brandItem " src="/images/29.png"/>
                <Image className="brandItem " src="/images/30.png"/>
                <Image className="brandItem " src="/images/31.png"/>
                <Image className="brandItem " src="/images/32.png"/>
                <Image className="brandItem " src="/images/33.png"/>
            </div>
        </ScrollAnimation>
        </Container>
        
        </div>
    )
}

export default About;